import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Card, Divider, FormLabel, SkeletonText } from '@tq/ui-components';

import { Consultation, PastResponse } from 'types';
import { UploadedDocumentCard } from '../UploadedDocumentCard';

export type ArchivedPastResponseCardProps = {
  response: PastResponse | undefined;
  consultation: Consultation | undefined;
};
export const ArchivedPastResponseCard: React.FC<ArchivedPastResponseCardProps> = ({
  response,
  consultation,
}) => {
  const { t } = useTranslation('archived_details_view');

  if (!response) {
    return <SkeletonText />;
  }

  return (
    <Card
      py={{ base: 0, lg: 8 }}
      px={{ base: 0, lg: 6 }}
      border={{ base: 'none', lg: `1px solid ${COLOURS.gray[200]}` }}
    >
      <FormLabel mb={2}>{t('response_type', 'Response type')}</FormLabel>
      <span>{response.type}</span>
      {!!response.response?.length && (
        <>
          <FormLabel mt={6} mb={2}>
            {t('summary', 'Summary')}
          </FormLabel>
          <p>{response.response}</p>
        </>
      )}
      {!!response.reasonForLateResponse && (
        <>
          <FormLabel mt={6} mb={2}>
            {t('reason_for_late_response', 'Reason for late response')}
          </FormLabel>
          <p>
            {response.reasonForLateResponse}
            {response.reasonForLateResponseDetail &&
              ` - ${response.reasonForLateResponseDetail}`}
          </p>
        </>
      )}

      {(!!response.document || !!response.supportingDocuments.length) && <Divider my={8} />}

      {!!response.document && consultation?.id && (
        <>
          <FormLabel mb={4}>{t('uploaded_response', 'Uploaded response')}</FormLabel>
          <UploadedDocumentCard
            uploadedDocuments={[response.document]}
            responseId={response.id}
            consultationId={consultation.id}
          />
        </>
      )}

      {!!response.supportingDocuments.length && consultation?.id && (
        <Box mt={8}>
          <FormLabel mt={1} mb={4}>
            {t('uploaded_supporting_documents', 'Uploaded supporting documents')}
          </FormLabel>
          <UploadedDocumentCard
            uploadedDocuments={response.supportingDocuments}
            responseId={response.id}
            consultationId={consultation.id}
          />
        </Box>
      )}
    </Card>
  );
};
